const initialState =
{
	id                    : null,
	picture               : null,
	browser               : null,
	roles                 : [ 'normal' ], // Default role
	canSendMic            : false,
	canSendWebcam         : false,
	canShareScreen        : false,
	canShareFiles         : false,
	audioDevices          : null,
	webcamDevices         : null,
	webcamInProgress      : false,
	audioInProgress       : false,
	screenShareInProgress : false,
	displayNameInProgress : false,
	loginEnabled          : false,
	raisedHand            : false,
	raisedHandInProgress  : false,
	loggedIn              : false,
	isSpeaking            : false,
	isAutoMuted           : true,    // 由监听器控制

	preloadWebcam         : false,

	forceMuted            : false,  // 主持人是否强制关闭了mic
	applyUnMuted          : false,  // 终端申请状态
	allowUnMuted          : false,  // 审批结果 (同意/拒绝)

	applyUnMutedInProgress: false,

	chairAudioMuteInProgress   : false,  //
	chairVideoMuteInProgress   : false,  //

	userInfo              : null,   // 用户登录信息(包括 token )
	loggedExpired         : false,  // 登录超时, 默认 5 分钟

	virtualRealityEnabled : false,  // 是否开启虚拟背景
	virtualBgUrl          : window.app_base_path + '/images/virtualBg/tainan.jpeg',    // 虚拟背景图片地址
	loginType             : 'hj'   // hj zy
};

const me = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_ME':
		{
			const {
				peerId,
				loginEnabled
			} = action.payload;

			return {
				...state,
				id : peerId,
				loginEnabled
			};
		}

		case 'SET_MY_PEER_ID':
		{
			const {
				peerId
			} = action.payload;

			return {
				...state,
				id : peerId
			};
		}

		case 'SET_BROWSER':
		{
			const { browser } = action.payload;

			return { ...state, browser };
		}

		case 'SET_LOGGED_IN':
		{
			const { flag } = action.payload;

			return { ...state, loggedIn: flag };
		}

		case 'SET_LOGGED_EXPIRED':
		{
			const { flag } = action.payload;

			return { ...state, loggedExpired: flag };
		}

		case 'ADD_ROLE':
		{
			if (state.roles.includes(action.payload.role))
				return state;

			const roles = [ ...state.roles, action.payload.role ];

			return { ...state, roles };
		}

		case 'REMOVE_ROLE':
		{
			const roles = state.roles.filter((role) =>
				role !== action.payload.role);

			return { ...state, roles };
		}

		case 'SET_PICTURE':
			return { ...state, picture: action.payload.picture };

		case 'SET_MEDIA_CAPABILITIES':
		{
			const {
				canSendMic,
				canSendWebcam,
				canShareScreen,
				canShareFiles
			} = action.payload;

			return {
				...state,
				canSendMic,
				canSendWebcam,
				canShareScreen,
				canShareFiles
			};
		}

		case 'SET_AUDIO_DEVICES':
		{
			const { devices } = action.payload;

			return { ...state, audioDevices: devices };
		}

		case 'SET_AUDIO_OUTPUT_DEVICES':
		{
			const { devices } = action.payload;

			return { ...state, audioOutputDevices: devices };
		}

		case 'SET_WEBCAM_DEVICES':
		{
			const { devices } = action.payload;

			return { ...state, webcamDevices: devices };
		}

		case 'SET_AUDIO_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, audioInProgress: flag };
		}

		case 'SET_WEBCAM_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, webcamInProgress: flag };
		}

		case 'SET_PRELOAD_WEBCAM':
		{
			const { flag } = action.payload;

			return { ...state, preloadWebcam: flag };
		}

		case 'SET_SCREEN_SHARE_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, screenShareInProgress: flag };
		}

		case 'SET_RAISED_HAND':
		{
			const { flag } = action.payload;

			return { ...state, raisedHand: flag };
		}

		case 'SET_RAISED_HAND_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, raisedHandInProgress: flag };
		}

		case 'SET_DISPLAY_NAME_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, displayNameInProgress: flag };
		}

		case 'SET_IS_SPEAKING':
		{
			const { flag } = action.payload;

			return { ...state, isSpeaking: flag };
		}

		case 'SET_AUTO_MUTED':
		{
			const { flag } = action.payload;

			return { ...state, isAutoMuted: flag };
		}
		case 'SET_FORCE_MUTED': // 设置被强制静音状态
		{
			const { flag } = action.payload;

			return { ...state, forceMuted: flag };
		}

		case 'SET_APPLY_UNMUTED':  // 被强制静音了，申请请求
		{
			const { flag } = action.payload;

			return { ...state, applyUnMuted: flag };
		}

		case 'SET_ALLOW_UNMUTED':  // 被强制静音了，申请处理结果
		{
			const { flag } = action.payload;

			return { ...state, allowUnMuted: flag };
		}

		case 'SET_APPLY_UNMUTED_IN_PROGRESS': // 申请处理中
		{
			const { flag } = action.payload;

			return { ...state, applyUnMutedInProgress: flag };
		}

		case 'SET_CHAIR_AUDIO_MUTE_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, chairAudioMuteInProgress: flag };
		}

		case 'SET_CHAIR_VIDEO_MUTE_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, chairVideoMuteInProgress: flag };
		}

		case 'SET_USER_INFO':  // bingofree 添加
		{
			const { userInfo } = action.payload;

			return { ...state, userInfo };
		}

		case 'SET_VIRTUAL_REALITY_ENABLED':
		{
			const { flag } = action.payload;

			return { ...state, virtualRealityEnabled: flag };
		}

		case 'SET_VIRTUAL_BG_URL':
		{
			const { imgUrl } = action.payload;

			return { ...state, virtualBgUrl: imgUrl };
		}

		case 'SET_LOGIN_TYPE':
		{
			const { loginType } = action.payload;

			return { ...state, loginType };
		}

		default:
			return state;
	}
};

export default me;
